<div class="modal-header">
    <h4 class="modal-title">{{ "alertModal.notification" | translate }}</h4>
</div>
<div class="modal-body">
    {{ message | translate }}
</div>
<div class="modal-footer">
    <button type="button" class="btn btn-primary" (click)="accept()"> {{ "alertModal.ok" | translate }}</button>
</div>